module.exports = __webpack_public_path__ + "b09849f22488ffa87d3e1bbdb5a7e442.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ping-pong-s.png
// module id = 2580
// module chunks = 0